// extracted by mini-css-extract-plugin
export default {"forgot-password-container":"ForgotPassword_forgot-password-container__GSzKe","amplify":"ForgotPassword_amplify__CTv+B"};